// extracted by mini-css-extract-plugin
module.exports = {"container":"PalettePage_container___ldl4"};